let userTokenMemory = ''


export const decodeJwt = token => {
  try {
    return JSON.parse(atob(token.split('.')[1]))
  } catch (e) {
    return null
  }
}


export const getUserTokenFromCookie = () =>
  getCookieValue(process.env.REACT_APP_USER_TOKEN_KEY) || userTokenMemory


// "Continue with ConsultDex Community" signs in on the site, which sends the visitor back
// here with the token in the fragment (#cdx_token=…); a fragment never reaches a server.
// Store it like a password sign-in's token and clear it from the address.
export const takeTokenFromFragment = () => {
  const match = window.location.hash.match(/(?:^#|&)cdx_token=([^&]+)/)
  const token = match ? decodeURIComponent(match[1]) : ''

  if (!token || !decodeJwt(token)) {
    return null
  }

  setUserTokenCookie(token)
  window.history.replaceState(null, '', window.location.pathname + window.location.search)

  return token
}


// The site's community sign-in, returning to where the visitor was headed.
export const getCommunitySignInUrl = () => {
  const signIn = new URL(`${process.env.REACT_APP_WP_API_URL}/wp-admin/admin-post.php`)

  signIn.searchParams.set('action', 'cdx_community_login')
  signIn.searchParams.set('redirect_to', getRedirectionUrl(window.location.href))

  return signIn.toString()
}


export const redirectToLogin = () => {
  if (isCurrentlyOnLogin()) {
    return
  }

  window.location.assign(getLoginUrlWithRedirection(window.location.href))
}


export const followRedirectUrl = () => {
  window.location.replace(getRedirectionUrl(window.location.href))
}


export const getFrontEndUrlFromRedirection = () => {
  const redirectionUrl = getRedirectionUrl(window.location.href)
  const frontEndUrl = process.env.REACT_APP_WP_API_URL

  if (redirectionUrl.startsWith(frontEndUrl)) {
    return redirectionUrl
  }

  return frontEndUrl
}


export function isCurrentlyOnLogin() {
  return window.location.href.startsWith(getLoginUrl())
}


export function setUserTokenCookie(token) {
  userTokenMemory = token

  const domain = getCookieDomainAttribute(process.env.REACT_APP_COOKIE_DOMAIN)

  document.cookie = `${process.env.REACT_APP_USER_TOKEN_KEY}=${token};path=/;max-age=31536000${domain}`
}


/** helper for Unit Testing */
export const privateFunctions = {
  getCookieDomainAttribute,
  getLoginUrlWithRedirection,
  getRedirectionUrl
}


function getLoginUrlWithRedirection(redirectionUrl) {
  const loginUrl = new URL(getLoginUrl())

  const skipRedirectionUrls = [
    getLoginUrl(),
    getPublicUrl()
  ]


  if (redirectionUrl && !skipRedirectionUrls.includes(redirectionUrl)) {
    loginUrl.searchParams.set('redirect', redirectionUrl)
  }

  return loginUrl.toString()
}


function getRedirectionUrl(url) {
  const redirectionUrl = (new URL(url)).searchParams.get('redirect')

  if (redirectionUrl) {
    return redirectionUrl
  }

  return getPublicUrl()
}


function getLoginUrl() {
  return `${getPublicUrl()}/login`
}


function getPublicUrl() {
  if (process.env.PUBLIC_URL) {
    return process.env.PUBLIC_URL
  }

  return window.location.origin
}


function getCookieDomainAttribute(cookieDomain) {
  if (!cookieDomain) {
    return ''
  }

  const hostName = window.location.hostname
  const normalizedDomain = cookieDomain.replace(/^\./, '')

  if ((hostName === normalizedDomain) || hostName.endsWith(`.${normalizedDomain}`)) {
    return `;domain=${cookieDomain}`
  }

  return ''
}


function getCookieValue(cookieName) {
  const b = document.cookie.match(`(^|;)\\s*${cookieName}\\s*=\\s*([^;]+)`)

  return b ? b.pop() : ''
}
